import { useMutation, useQueryClient } from 'react-query';
import { patchAssignManagers } from '../../api/medtech-api';

interface UseAssignManagersParams {
  companyId: number;
  groupId: number;
}

interface AssignManagersParams {
  managerIdsToAdd: number[];
  managerIdsToRemove: number[];
}

export const useAssignManagers = ({ companyId, groupId }: UseAssignManagersParams) => {
  const queryClient = useQueryClient();

  const assignManagersMutation = useMutation({
    mutationFn: ({ managerIdsToAdd, managerIdsToRemove }: AssignManagersParams) =>
      patchAssignManagers(companyId, groupId, managerIdsToAdd, managerIdsToRemove),

    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users', companyId] });
      queryClient.invalidateQueries({ queryKey: ['groups', companyId] });
    },
  });

  return {
    assignManagers: assignManagersMutation.mutateAsync,
    isAssigning: assignManagersMutation.isLoading,
    isError: assignManagersMutation.isError,
    error: assignManagersMutation.error,
  };
};
